import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PropertyService {
  constructor(private api: ApiService) {}

  // GET API

  getPropertiesList(payload: any) {
    return this.api.get(`/property?office_id=${this.api.getOfficeId()}`, payload);
  }
  getPropertyById(property_id: any) {
    return this.api.get(`/property/${property_id}`);
  }
  getPropertyView() {
    return this.api.get(`/user-office-grid?type=${'property'}&office_id=${this.api.getOfficeId()}`);
  }
  getPropertyAppraisal(property_id: any) {
    return this.api.get(`/property-appraisals?property_id=${property_id}&office_id=${this.api.getOfficeId()}`);
  }

  getSuburb(query: string) {
    return this.api.get('/suburbs/get?suburb=' + query);
  }

  // POST API

  getPropertiesByFilter(payload: any) {
    return this.api.post(`/property/filter?office_id=${this.api.getOfficeId()}&page=${payload?.page}&per_page=${payload?.per_page}`, payload);
  }
  createPropertyView(payload: any) {
    return this.api.post('/user-office-grid', payload);
  }
  createProperty(payload: any) {
    return this.api.post(`/property`, payload);
  }
  createPropertyAppraisal(payload: any) {
    return this.api.post('/property-appraisals/', payload);
  }
  savePropertyHistory(payload: any) {
    return this.api.post('/property-manual-history/', payload);
  }

  // PUT API

  updatePropertyById(property_id: any, payload: any) {
    return this.api.put(`/property/${property_id}`, payload);
  }
  updatePropertyAppraisal(appraisal_id: any, payload: any) {
    return this.api.put('/property-appraisals/' + appraisal_id, payload);
  }
  updateManualHistory(id: any, payload: any) {
    return this.api.put('/property-manual-history/' + id, payload);
  }
  saveContactHistory(id: any, contact_id) {
    return this.api.put('/contact-association/' + id, contact_id);
  }

  // DELETE API

  deletePropertyById(property_id: any) {
    return this.api.delete(`/property/${property_id}`);
  }
  deletePropertyAppraisal(appraisal_id: any) {
    return this.api.delete('/property-appraisals/' + appraisal_id);
  }
}
